/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { createRoot } from 'react-dom/client'
// need here to include library styles before app styles
import { loadScript } from 'services/Analytics/services/TealiumUTag/utils'
import IEWarning from 'shared/apps/IEWarning'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'assets/styles/main.css'

const MOUNT_NODE: any = document.getElementById('root')
let root = createRoot(MOUNT_NODE!)

if((navigator.userAgent.indexOf('MSIE') !== -1) || (!!document.documentMode === true)) {
  root.render(<IEWarning />)
} else {
  Promise.all([import('redux-app'), import('./root/AppContainer'), loadScript()])
    .then(([{ default: store }, { default: AppContainer }]) => {
      let render = () => {
        root.render(<AppContainer store={store}/>)
      }

      // Development Tools
      // ------------------------------------
      if(__DEV__) {
        if(module.hot) {
          const renderApp = render
          const renderError = error => {
            root.render(<div>Something went wrong:
              <div>{error}</div>
            </div>)
          }

          render = () => {
            try {
              renderApp()
            } catch(e) {
              console.error(e)
              renderError(e)
            }
          }
        }
      }

      // Let's Go!
      // ------------------------------------
      if(!__TEST__) render()
    })
}
